@if (order().showOrderNumberQrCode && isMobileSmDown()) {
  <div class="qr-block">
    <p>QR - code для получения заказа и въезда на склад</p>

    <button type="button" (click)="openQrModal($event, order().code)">
      <qrcode width="70" [qrdata]="order().code" errorCorrectionLevel="L"></qrcode>
    </button>
  </div>
}

<div class="heading">
  <div>
    <div class="status">
      @if (order().statusDisplay) {
        <sd-order-status-label
          [text]="order().statusDisplay"
          [code]="order().status ? order().status : 'PROCESSING'"
        ></sd-order-status-label>
      }
    </div>

    <div>
      <span class="code">{{ order().code }}</span>
      <span class="date">{{ ' от ' + (order().placed | date: 'dd MMMM yyyy') }}</span>
    </div>
  </div>

  @if (order().total?.formattedValue) {
    <div class="price">
      @if (!isMobileSmDown()) {
        <span class="sum">сумма</span>
      }
      <span>
        {{ order().total?.formattedValue }}
      </span>
    </div>
  }
</div>

@if (order().entries?.length) {
  <div class="entries">
    @for (entry of order().entries | slice: 0 : shownEntriesCount(); track $index; let i = $index) {
      <div class="img-item">
        @if (entry.product) {
          @if (entry.product.images?.length) {
            <sd-media
              [width]="100"
              [height]="100"
              loading="eager"
              fetchpriority="high"
              [container]="entry.product.images"
            ></sd-media>
          } @else {
            <img class="no-img" [width]="100" [height]="100" src="assets/images/product-photo-missing.svg" alt="" />
          }

          @if (i === shownEntriesCount() - 1 && order().entries?.length > shownEntriesCount()) {
            <span class="more-items">+{{ order().entries?.length - i - 1 }}</span>
          }
        }
      </div>
    }
  </div>
}

@if (order().storeUntilDateInfo) {
  <span>{{ order().storeUntilDateInfo }}</span>
}
